export default __webpack_public_path__ + "static/media/WhatsApp Image 2025-09-30 at 12.32.01 PM.86747c85.jpeg";